module.exports = __webpack_public_path__ + "img/key_white_24dp@2x.cac671ca.png";